export const APP_VERSION = '0.5.0';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LangProvider } from './context/LangContext';
import Layout from './components/Layout';
import LoginPage          from './pages/LoginPage';
import Dashboard          from './pages/Dashboard';
import ConnectionsPage    from './pages/ConnectionsPage';
import InvoicesPage       from './pages/InvoicesPage';
import InvoiceUploadPage  from './pages/InvoiceUploadPage';
import InvoiceDetailPage  from './pages/InvoiceDetailPage';
import AnalyticsPage      from './pages/AnalyticsPage';
import UsersPage          from './pages/UsersPage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user)   return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return null;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/"                element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/connections"     element={<ProtectedRoute><ConnectionsPage /></ProtectedRoute>} />
      <Route path="/invoices"        element={<ProtectedRoute><InvoicesPage /></ProtectedRoute>} />
      <Route path="/invoices/upload" element={<ProtectedRoute><InvoiceUploadPage /></ProtectedRoute>} />
      <Route path="/invoices/new"    element={<ProtectedRoute><InvoiceDetailPage /></ProtectedRoute>} />
      <Route path="/invoices/:id"    element={<ProtectedRoute><InvoiceDetailPage /></ProtectedRoute>} />
      <Route path="/analytics"       element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
      <Route path="/users"           element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </LangProvider>
    </BrowserRouter>
  );
}
